import SmartImage from './SmartImage'

export default SmartImage
